import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import notificationService from "services/notificationService";

export const usePopupNotificationList = (onSuccess, onError) => {
  const { t } = useTranslation(["notificationManagement"]);

  return useQuery(
    ["notification_popup"],
    () => notificationService.listPopupNotification(),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data?.items || [],
          totalCount: data?._meta ? data?._meta?.totalCount : data?.items?.length,
        };
      },
    }
  );
};

export const useReadNotification = (onSuccess, onError) => {
  const { t } = useTranslation(["notificationManagement"]);

  return useMutation(notificationService.markReadNotification, {
    retry: 0,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useReadAllNotification = (onSuccess, onError) => {
  const { t } = useTranslation(["notificationManagement"]);

  return useQuery(
    ["notification_list"],
    () => notificationService.markReadAllNotification(),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

export const useNotificationList = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["notificationManagement"]);

  const { params } = payload;

  return useQuery(
    ["notification_list"],
    () => notificationService.listManagementNotification(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useUploadTokenDevice = (onSuccess, onError) => {
  const { t } = useTranslation(["notificationManagement"]);

  return useMutation(notificationService.uploadDeviceToken, {
    retry: 0,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
